<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">字典管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <div style="display:inline-block;" v-if="isbutShow.selectBut">
             <template>
                <Input v-model="key" placeholder="字典名称" style="width: 300px"></Input>
            </template>

              <Button type="ghost" class="mRight mLeft" @click="showKeyList()">查询</Button>

            </div>

            <Button @click="addAdmin" type="primary" class="mRight" v-if="isbutShow.addBut">新增</Button>
            <Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>

          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-totalapi  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  <!-- 新增字典  / 修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="字典名称" prop="name">
                  <Input v-model="formValidate.name" placeholder=字典名称></Input>
              </FormItem>
              <FormItem label="字典类型" prop="type">
                  <Input  v-model="formValidate.type"   placeholder="字典类型"></Input>
              </FormItem>
              <FormItem label="字典码" prop="code">
                  <Input v-model="formValidate.code"  placeholder="字典码"></Input>
              </FormItem>
              <FormItem label="字典值" prop="value">
                  <Input v-model="formValidate.value" placeholder="字典值"></Input>
              </FormItem>
               <FormItem label="排序" prop="orderNum">
                  <Input v-model="formValidate.orderNum" placeholder="排序" v-on:blur="isMobile()" ></Input>
              </FormItem>
            <FormItem label="备注" prop="remark">
              <Input v-model="formValidate.remark" placeholder="备注" v-on:blur="isMobile()" ></Input>
            </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>


  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  // .ivu-modal-footer{
  //   text-align:center !important;
  // }
  // .ivu-form-item-content{
  //   text-align:left;
  // }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/tree'
  // import dateformat from '../../util/dateformat'

  // import api from '../../api/commonApi'
  export default{
    data(){

      return {
       isbutShow:{
        addBut: ' ',
        delBut: ' ',
        updateBut: ' ',
        selectBut: ' ',
       },
        modelName:'新增',
        key:'',
        pagerData:{
           data:[],
           page:{
              //分页数
               // arrPageSize:[10,20,30,40],
               //分页大小
               pagesize:10,
               //总分页数
               pageCount:1,
               //当前页面
               pageCurrent:1,
               //总数
               totalCount:0
           }

        },
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: '字典名称',
                key: 'name',
                align: 'center'
            },
            {
                title: '字典类型',
                key: 'type',
                align: 'center'
            },
            {
                title: '字典码',
                key: 'code',
                align: 'center'
            },
            {
                title: '字典值',
                key: 'value',
                align: 'center'
            },
            {
                title: '排序',
                key: 'orderNum',
                align: 'center'
            },
            {
                title: '备注',
                key: 'remark',
                align: 'center'
            },

        ],
        addModel: false,
        modalDept:false,
        resourcesDept:[],
        treeNode:'所属部门',
        treeNodeId:'',
        deptLists:[
          {
            title: 'parent 1',
            expand: true,
            // selected: true,
            children: [
                {
                    title: 'parent 1-1',
                    expand: true,
                    children: [
                        {
                            title: 'leaf 1-1-1',
                            // disabled: true
                        },
                        {
                            title: 'leaf 1-1-2'
                        }
                    ]
                },
                {
                    title: 'parent 1-2',
                    expand: true,
                    children: [
                        {
                            title: 'leaf 1-2-1',
                            // checked: true
                        },
                        {
                            title: 'leaf 1-2-1'
                        }
                    ]
                }
            ]
          }
        ],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        selectionRows:{},
        updateId:'',
        formValidate: {
            name: '',
            type:'',
            code:'',
            value:'',
          orderNum: '',
          remark: '',
        },
        ruleValidate: {
            name: [
                { required: true, message: '字典不能为空', trigger: 'blur' }
            ],
            type:[
                { required: true,message: '字典类型不能为空',trigger: 'blur' },
            ],
            code:[
                { required: true,message:'字典码不能为空', trigger: 'blur' }
            ],
            value:[
               { required: true, message: '字典值不能为空',  trigger: 'blur' }
            ],
          orderNum: [
                { required: true, message: '排序不能为空', trigger: 'blur' },
            ],
          remark: [
                { required: true, message: '备注不能为空', trigger: 'blur' }
            ],

        },
        modal_loading: false,

      }
    },
    mounted:function(){
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        this.getDepartment()

    },
    methods: {
      //展示list
        getLists(pageCurrent,pagesize){
            api.Dict.getList({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              // console.log(resp)
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
              // this.getallgateway();
            }, error => {

            })
        },
        // 搜索关键词
        showKeyList(){
            // if(this.key == ''){
            //      this.$Message.error('查询关键词不能为空!');
            // }else{
              // console.log('通过关键词获取列表')
               api.Dict.getList({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'name':this.key,
                    // 'token':token
                }, resp => {
                  // console.log(resp)
                  // 获取分页展示list
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   //this.key = '';
                }, error => {

                })

            // }
        },
        getDepartment:function(){
            var token = sessionStorage.getItem("token");
            axios.get('http://115.29.214.141:8093/web/sys/dict/list',{params:{
                'token':token
              }},{
              headers: {
                "Content-Type": "application/json",
                'token':token
              }

            }).then(function (response) {
               console.log(response.data);


            }).catch(function (error) {
                console.log(error)
            });

        },
        getDeptNodes:function(tree){
            // console.log('tree'+tree);
            this.treeNode = tree.name;
            this.treeNodeId = tree.deptId;

        },
        closeDeptModal:function(){
            if(this.treeNode == '所属部门'){
              this.$Message.error('请选择所属部门!');
            }else{
              this.modalDept = false;
              this.formValidate.dePtNode = this.treeNode;
            }

        },

        handleSelect(selectedList){
            var ele = selectedList[selectedList.length-1] //当前选中的树节点
            ele.expand = true //设置为展开
        },

        handleReset (name) {
            this.$refs[name].resetFields();
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.formValidate.dePtNode == ''){
                    this.$Message.error('请选择所属部门!');
                  }
                  if(this.modelName == "修改"){
                    api.Dict.updateDict({
                      "id":this.updateId,
                      "name": this.formValidate.name,
                      "type": this.formValidate.type,
                      "code": this.formValidate.code,
                      "value": this.formValidate.value,
                      "orderNum": this.formValidate.orderNum,
                      "remark": this.formValidate.remark,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                      }
                      this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                    }, error => {

                    })
                  }else if(this.modelName == "新增"){
                    api.Dict.addDict({
                      "name": this.formValidate.name,
                      "type": this.formValidate.type,
                      "code": this.formValidate.code,
                      "value": this.formValidate.value,
                      "orderNum": this.formValidate.orderNum,
                      "remark": this.formValidate.remark,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;

                      }
                      this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                    }, error => {

                    })
                  }


                } else {
                    this.$Message.error('Fail!');
                }
            })


        },

        // 删除/批量删除
        delAdmins(){
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
            this.$Message.error('请选择一条记录!');
            return;
          }
            var ids = [];
          console.log("长度："+this.selectionRows.length);
            for(var i=0 ;i < this.selectionRows.length; i++){
                ids.push(this.selectionRows[i].id);
            }
            console.log(ids)
            // 执行删除
            this.delAdmin(ids);
        },
        // 新增 初始化数据
        addAdmin:function(){
            this.modelName = '新增';
            this.formValidate = {
            name: '',
            type:'',
            code:'',
            value:'',
            orderNum: '',
            remark:'',
          }
           this.addModel = true;
        },
      //删除
      delAdmin:function(ids){
        console.log(ids)
        api.Dict.deleteDict(
         ids
        , resp => {
          // console.log(resp)
          // 获取分页展示list
          // this.pagerData.data = resp.page.list;
          // // 获取分页总条数
          // this.pagerData.page.totalCount = resp.page.totalCount;
          // // this.getallgateway();
          if(resp.code == 0){
            this.$Message.success('删除成功!');

          }
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        }, error => {

        })

      },

        // 修改
        upDateAdmin:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          this.updateId = this.selectionRows[0].id
          this.formValidate = {
            name: this.selectionRows[0].name,
            type:this.selectionRows[0].type,
            code:this.selectionRows[0].code,
            value:this.selectionRows[0].value,
            orderNum: this.selectionRows[0].orderNum,
            remark: this.selectionRows[0].remark,
          }
          this.addModel = true;

        },

        getSelection:function(selection){
            console.log(selection)
            this.selectionRows = selection;
        },

        formatDate (date) {
          // console.log(date)
          date = new Date()
           // console.log(date)
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d;
             // return dateformat(date,'YYYY-MM-dd');
        },

        // 分页 -- 页数改变
        onChange:function(curpage){
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        } ,


    },

      components: {treeCom}
    }
</script>



// WEBPACK FOOTER //
// dict.vue?4288c035